import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectAdminInfo } from '../../redux/features/admin/adminSelectors'

const ProtectedRoute = ({ children }: any) => {
  const location = useLocation()
  const adminInfo = useSelector(selectAdminInfo)

  console.log("AMIN INFO", adminInfo)

  if (!adminInfo) {
    console.log('[ProtectedRoute] User not authenticated, redirecting to /login from:', location.pathname)
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  console.log('[ProtectedRoute] User authenticated, allowing access to:', location.pathname)
  return children
}

export default ProtectedRoute
